// Module
var code = `<ngx-wizard-view class="quick-start-guide-wizard-view"><quick-start-guide lms-name="{{\$ctrl.wizardController.lmsName}}" ng-init="\$ctrl.wizardController.setContentLoaded(true)"></quick-start-guide></ngx-wizard-view>`;
// Exports
export default code;